var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 599,
    viewBox: "0 0 1024 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.415 123.367H279.328V332.044C279.328 364.121 271.135 388.005 254.747 403.695C238.36 419.385 215.871 427.23 187.28 427.23C162.874 427.23 143.523 422 129.227 411.54C115.281 401.08 104.646 387.831 97.3244 371.792L131.319 346.165C138.293 360.46 145.963 370.223 154.331 375.453C163.048 380.334 172.636 382.775 183.096 382.775C200.181 382.775 212.559 378.242 220.229 369.177C227.9 359.763 231.735 347.56 231.735 332.567V123.367H166.883V82.05H315.415V123.367ZM571.959 305.371C571.959 341.284 560.802 370.572 538.487 393.235C516.521 415.898 487.407 427.23 451.146 427.23C415.582 427.23 387.34 416.247 366.42 394.281C345.849 372.315 335.563 343.376 335.563 307.463C335.563 273.294 345.5 244.006 365.374 219.599C385.248 195.192 414.885 182.989 454.284 182.989C493.683 182.989 523.146 195.192 542.671 219.599C562.196 243.657 571.959 272.248 571.959 305.371ZM523.843 303.802C523.843 278.001 517.393 257.604 504.492 242.611C491.94 227.618 474.855 220.122 453.238 220.122C430.575 220.122 413.141 228.141 400.938 244.18C389.083 259.87 383.156 280.093 383.156 304.848C383.156 328.557 388.909 348.78 400.415 365.516C412.27 381.903 429.703 390.097 452.715 390.097C475.378 390.097 492.812 382.078 505.015 366.039C517.567 349.652 523.843 328.906 523.843 303.802ZM638.184 133.304V79.435H686.3V133.304H638.184ZM686.3 424.615C686.3 468.896 677.235 499.753 659.104 517.186C640.973 534.619 614.998 541.767 581.177 538.629L579.608 506.203C589.022 506.203 598.436 504.634 607.85 501.496C617.264 498.358 624.935 491.036 630.862 479.53C637.138 468.024 640.276 449.719 640.276 424.615V224.306H593.206V188.219H686.3V424.615ZM974.935 305.371C974.935 341.284 963.777 370.572 941.463 393.235C919.497 415.898 890.383 427.23 854.122 427.23C818.558 427.23 790.316 416.247 769.396 394.281C748.824 372.315 738.539 343.376 738.539 307.463C738.539 273.294 748.476 244.006 768.35 219.599C788.224 195.192 817.86 182.989 857.26 182.989C896.659 182.989 926.121 195.192 945.647 219.599C965.172 243.657 974.935 272.248 974.935 305.371ZM926.819 303.802C926.819 278.001 920.368 257.604 907.468 242.611C894.916 227.618 877.831 220.122 856.214 220.122C833.55 220.122 816.117 228.141 803.914 244.18C792.059 259.87 786.132 280.093 786.132 304.848C786.132 328.557 791.885 348.78 803.391 365.516C815.245 381.903 832.679 390.097 855.691 390.097C878.354 390.097 895.787 382.078 907.991 366.039C920.543 349.652 926.819 328.906 926.819 303.802Z",
    fill: "#0F2C7A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 92,
    r: 12,
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 120,
    r: 12,
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 78,
    r: 12,
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 105,
    r: 12,
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404,
    cy: 130,
    r: 12,
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 105,
    r: 12,
    fill: "#005AFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638,
    y: 78,
    width: 49,
    height: 56,
    fill: "#EEC90F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 599,
    rx: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8bc33ad734a02c13d08662a9b5529440.svg";
export { ForwardRef as ReactComponent };